<style lang="less" scoped>
.description-list{
  .detail-title{
    margin-bottom: 0px;
  }
  &.description-list-collapse{
    ::v-deep .ant-descriptions-bordered{
      .ant-descriptions-view{
        border: none;
      }
    }
  }
}
</style>

<template>
  <div class="description-list" :class="{ 'description-list-collapse': collapse }" >
    <a-descriptions :column="collapse ? [] : column" bordered>
      <template v-if="title" #title>
        <DetailTitle :title="title" :collapse="collapse" @collapse="onCollapseChange" />
      </template>
      <template v-if="!collapse">
        <a-descriptions-item
          v-for="val in list"
          :key="val.prop"
          :label="val.name"
          :span="val.span"
          :labelStyle="val.labelStyle"
          :contentStyle="val.contentStyle"
        >
          <span v-if="!val.slot" @click="val.click ? val.click(currentData) : undefined" >{{ !val.format ? currentData[val.prop] : val.format(currentData[val.prop], currentData) }}</span>
          <slot v-else :name="val.slot" :currentData="currentData" />
        </a-descriptions-item>
      </template>
    </a-descriptions>
  </div>
</template>

<script lang="ts">
import { CSSProperties, PropType, defineComponent } from 'vue'
import DetailTitle from './DetailTitle.vue'

type itemType = {
  prop: string
  name: string
  span?: number
  labelStyle?: CSSProperties
  contentStyle?: CSSProperties
  click?: (data: Record<string, unknown>) => void
  format?: (value: unknown, data: Record<string, unknown>) => string
  slot?: string
}

export default defineComponent({
  name: 'DescriptionList',
  components: {
    DetailTitle
  },
  props: {
    title: {
      type: String,
      required: true
    },
    column: {
      type: [Number, Object],
      required: false
    },
    data: {
      type: Object as PropType<Record<string, any>>,
      required: true
    },
    extraData: {
      type: Object as PropType<Record<string, any>>,
      required: false
    },
    list: {
      type: Object as PropType<itemType[]>,
      required: true
    },
    collapse: {
      type: Boolean,
      required: false
    },
  },
  computed: {
    currentData: function(): any {
      if (this.extraData) {
        return {
          ...this.data,
          ...this.extraData
        }
      } else {
        return {
          ...this.data
        }
      }
    }
  },
  data() {
    return {}
  },
  methods: {
    onCollapseChange(value: boolean) {
      this.$emit('collapse', value)
    }
  }
})
</script>
